import { OrganizationLanguage } from "src/types/enum/organization-language";

export enum NotificationMetadataKind {
  //TENANT
  BLACKLISTED_VEHICLE_LICENSE_PLATE_CREATED = "BLACKLISTED_VEHICLE_LICENSE_PLATE_CREATED",
  TENANT_GUEST_LICENSE_PLATES_ACCESS_ENABLED = "TENANT_GUEST_LICENSE_PLATES_ACCESS_ENABLED",
  TENANT_GUEST_LICENSE_PLATES_ACCESS_DISABLED = "TENANT_GUEST_LICENSE_PLATES_ACCESS_DISABLED",
  ORGANIZATION_SPOTS_ASSIGNED = "ORGANIZATION_SPOTS_ASSIGNED",
  EMPLOYEE_CREATED_ISSUE = "EMPLOYEE_CREATED_ISSUE",
  //SITE
  SITE_REMOVAL_APPROVAL_NEEDED = "SITE_REMOVAL_APPROVAL_NEEDED",
  SITE_REMOVAL_CANCELLED = "SITE_REMOVAL_CANCELLED",
  TENANT_INVITATION_ACCEPTED = "TENANT_INVITATION_ACCEPTED",
  TENANT_REMOVED = "TENANT_REMOVED",
  //SYSTEM
  SYSTEM_MESSAGE = "SYSTEM_MESSAGE",
}

type BlacklistedPlateNotificationMetadata = {
  kind: NotificationMetadataKind.BLACKLISTED_VEHICLE_LICENSE_PLATE_CREATED;
  blacklistedVehicleLicensePlateToken: string;
  employeeEmail: string;
  employeeToken: string;
  organizationToken: string;
  siteAdminEmail: string;
  siteAdminToken: string;
  siteToken: string;
  vehicleLicensePlate: string;
};

type TenantGuestPlatesAccessEnabledNotificationMetadata = {
  kind: NotificationMetadataKind.TENANT_GUEST_LICENSE_PLATES_ACCESS_ENABLED;
  canAddGuestsToAccessControlSystem: boolean;
  organizationToken: string;
  siteToken: string;
  tenantToken: string;
};

type TenantGuestPlatesAccessDisabledNotificationMetadata = {
  kind: NotificationMetadataKind.TENANT_GUEST_LICENSE_PLATES_ACCESS_DISABLED;
  canAddGuestsToAccessControlSystem: boolean;
  organizationToken: string;
  siteToken: string;
  tenantToken: string;
};

type EmployeeIssueNotificationMetadata = {
  kind: NotificationMetadataKind.EMPLOYEE_CREATED_ISSUE;
  employeeToken: string;
  issueToken: string;
  reservationToken: string | null;
};

type OrganizationSpotAssignedNotificationMetadata = {
  kind: NotificationMetadataKind.ORGANIZATION_SPOTS_ASSIGNED;
  organizationToken: string;
  siteToken: string;
  spotNumbers: string[];
  spotTokens: string[];
  tenantToken: string;
};

type SiteRemovalApprovalNeededNotificationMetadata = {
  kind: NotificationMetadataKind.SITE_REMOVAL_APPROVAL_NEEDED;
  siteToken: string;
};

type SiteRemovalCancelledNotificationMetada = {
  kind: NotificationMetadataKind.SITE_REMOVAL_CANCELLED;
  siteToken: string;
  requestedAt: string; // ISO date
  cancelledAt: string; // ISO date
};

type TenantInvitationAcceptedMetadata = {
  kind: NotificationMetadataKind.TENANT_INVITATION_ACCEPTED;
  siteToken: string;
  organizationAdminEmail: string;
  organizationName: string;
};

type TenantRemovedNotificationMetadata = {
  kind: NotificationMetadataKind.TENANT_REMOVED;
  tenantToken: string;
  organizationToken: string;
  siteToken: string;
  tenantName: string;
  organizationName: string;
  requestedAt: string; // ISO date
  removedAt: string; // ISO date
};

type SysteMessageNotificationMetadata = {
  kind: NotificationMetadataKind.SYSTEM_MESSAGE;
  campaignToken: string;
};

export type NotificationMetadata =
  | BlacklistedPlateNotificationMetadata
  | TenantGuestPlatesAccessEnabledNotificationMetadata
  | TenantGuestPlatesAccessDisabledNotificationMetadata
  | OrganizationSpotAssignedNotificationMetadata
  | EmployeeIssueNotificationMetadata
  | SiteRemovalApprovalNeededNotificationMetadata
  | SiteRemovalCancelledNotificationMetada
  | TenantInvitationAcceptedMetadata
  | TenantRemovedNotificationMetadata
  | SysteMessageNotificationMetadata;

export interface NotificationI {
  token: string;
  title: string;
  content: string;
  lang: OrganizationLanguage;
  isImportant: boolean;
  isRead: boolean;
  readtAt: string;
  metadata: NotificationMetadata;
  createdAt: string;
}
